<!-- nlc-style Dialog Header -->
<div class="nlc-dialog-header">
  <div class="dialog-icon-wrapper">
    <mat-icon class="dialog-icon">add_circle</mat-icon>
  </div>
  <h2 class="nlc-heading-3" mat-dialog-title>Coins hinzufügen</h2>
  <p class="nlc-body-secondary">Fügen Sie Coins zum Kundenkonto hinzu</p>
</div>

<!-- Dialog Content -->
<mat-dialog-content class="nlc-dialog-content">
  <form class="nlc-dialog-form">
    <!-- Amount Field -->
    <div class="form-group">
      <label class="nlc-label">
        <mat-icon class="label-icon">toll</mat-icon>
        Anzahl Coins
      </label>
      <mat-form-field appearance="outline" class="nlc-form-field">
        <input
          matInput
          type="number"
          [(ngModel)]="amount"
          name="amount"
          placeholder="z.B. 100"
          required
          min="1">
      </mat-form-field>
    </div>

    <!-- Reason Field -->
    <div class="form-group">
      <label class="nlc-label">
        <mat-icon class="label-icon">label</mat-icon>
        Grund
      </label>
      <mat-form-field appearance="outline" class="nlc-form-field">
        <mat-select [(ngModel)]="selectedReason" name="reason" required placeholder="Grund auswählen">
          <mat-option *ngFor="let reason of reasons$ | async" [value]="reason">
            {{ reason.reasonText }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>

<!-- Dialog Actions -->
<mat-dialog-actions class="nlc-dialog-actions">
  <button
    class="nlc-button nlc-button-primary"
    [disabled]="!amount || !selectedReason"
    (click)="addTransaction()">
    <mat-icon>add</mat-icon>
    Hinzufügen
  </button>
  <button class="nlc-button nlc-button-primary" mat-dialog-close>
    <mat-icon>close</mat-icon>
    Abbrechen
  </button>
</mat-dialog-actions>
